// extracted by mini-css-extract-plugin
export var activeTab = "AccountSettings-module--activeTab--4uqh2";
export var container = "AccountSettings-module--container--02ShL";
export var content = "AccountSettings-module--content--cBlGB";
export var tabContentTitle = "AccountSettings-module--tabContentTitle--GJblK";
export var tabs = "AccountSettings-module--tabs--hU26h";